import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatInputModule, MatSelectModule, MatSnackBarModule } from '@angular/material';
import { ServiceSuspendedDialogComponent } from './service-suspended-dialog/service-suspended-dialog.component';
import { CannotBlockPackageDialogComponent } from './cannot-block-package-dialog/cannot-block-package-dialog.component';
import { BlockPackageDialogComponent } from './block-package-dialog/block-package-dialog.component';
import { BlockPackageConfirmationDialogComponent } from './block-package-confirmation-dialog/block-package-confirmation-dialog.component';

@NgModule({
  declarations: [
    ServiceSuspendedDialogComponent,
    CannotBlockPackageDialogComponent,
    BlockPackageDialogComponent,
    BlockPackageConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
  ],
  entryComponents: [
    ServiceSuspendedDialogComponent,
    CannotBlockPackageDialogComponent,
    BlockPackageDialogComponent,
    BlockPackageConfirmationDialogComponent
  ]
})
export class DialogsModule { }
